// ! EGGHEAD USES DIFFERENT IDS DEPENDING IF IT'S A QUERY STRING PARAM OR URL SEGMENT
// ! REFER TO YOUR ROYALTY EMAIL
// ! THIS IS FOR A QUERY STRING PARAM
export const eggheadRefId = '2mdtw8'
